import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { Form, Input, message, Button } from 'antd';
import { common } from "../../utils"
const FormItem = Form.Item;
const formItemLayout = {
  labelCol: {
    span: 8
  },
  wrapperCol: {
    span: 16
  },
};

const tailFormItemLayout = {
  wrapperCol: {
    span: 16,
    offset: 8,
  },
};
export class AccountFindPwd extends Component {
  state = {
    codeTxt: "获取验证码",
    phone: "",
  }
  static propTypes = {
    center: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      values.TypeID = 1;
      if (!err) {
        this.props.actions.fetchEditStuPwd(values).then(res => {
          if (res.SuccessResponse) {
            message.success(res.Message);
          }
        })
      }
    });
  }
  getCode() {
    if (this.state.phone.trim() === "") {
      message.warn("手机号码不能为空");
      return;
    }
    if (common.checkPhone(this.state.phone)) {
      let seconds = 60;
      this.setState({
        codeTxt: "发送中..."
      })
      this.props.actions.fetchGetPhoneCodeByLogin({ Phone: this.state.phone }).then(res => {
        if (res.SuccessResponse) {
          message.success(res.Message);
          let timer = setInterval(() => {
            if (seconds > 0) {
              this.setState({
                codeTxt: `${seconds--}秒`
              })
            } else {
              clearInterval(timer);
              this.setState({
                codeTxt: "获取验证码",
              })
            }
          }, 1000)
        } else {
          message.warn(res.Message);
          this.setState({
            codeTxt: "获取验证码",
          })
        }
      })
    } else {
      message.warn("请输入正确的手机号")
    }
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    const { codeTxt } = this.state;
    return (
      <div className="center-account-find-pwd">
        <h1>
          *&nbsp;请输入手机号码找回密码
        </h1>
        <Form onSubmit={this.handleSubmit.bind(this)} autoComplete="off">
          <FormItem {...formItemLayout} label="手机号码">
            {getFieldDecorator('Phone', {
              rules: [
                {
                  required: true, message: "请输入手机号"
                },
                { pattern: "^[1][3,4,5,6,7,8,9][0-9]{9}$", message: "请输入正确的手机号" }
              ]
            })(
              <Input
                placeholder="请输入手机号"
                onChange={e => this.setState({
                  phone: e.target.value
                })}
                style={{ width: '300px', height: '40px' }}
                autoComplete="off" />
            )}
          </FormItem>
          <FormItem {...formItemLayout} label="验证码">
            {getFieldDecorator('PhoneCode', {
              initialValue: '123456',
              rules: [
                {
                  required: true, message: "请输入验证码"
                }
              ]
            })(
              <Input placeholder="请输入验证码" style={{ width: '300px', height: '40px' }} suffix={
                <span className="getCodeTxt" onClick={() => {
                  if (codeTxt === "获取验证码") {
                    this.getCode();
                  }
                }}>{codeTxt}</span>
              } autoComplete="off" />
            )}
          </FormItem>
          <Form.Item {...formItemLayout} label="新密码">
            {getFieldDecorator('newPassword', {
              rules: [{ required: true, message: '请输入新密码' }, {
                min: 6, message: "字符长度不小于六位"
              }, {
                max: 23, message: "字符长度不超过十六位"
              }, {
                validator: (rule, value, cb) => {
                  let lvl = 0;
                  if (/[0-9]/.test(value)) {
                    lvl++;
                  }
                  if (/[a-zA-Z]/.test(value)) {
                    lvl++;
                  }
                  if (/[^0-9a-zA-Z_]/.test(value)) {
                    lvl++;
                  }
                  if (lvl >= 2) {
                    cb();
                  } else {
                    cb('新密码不符合提示要求')
                  }
                }
              }],
            })(
              <Input.Password
                placeholder="新密码"
                style={{ width: 300, height: 40 }}
              />,
            )}
            <p className="tip">密码长度6-23位，须包含数字、字母、符号至少2种或以上元素</p>
          </Form.Item>
          <Form.Item {...tailFormItemLayout}>
            <Button type="theme" htmlType="submit" className="submitBtn">
              确认
              </Button>
          </Form.Item>
        </Form>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    center: state.center,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Form.create()(AccountFindPwd));



// WEBPACK FOOTER //
// ./src/features/center/AccountFindPwd.js